import { render, staticRenderFns } from "./BestellungWarenkorb.vue?vue&type=template&id=30566692&"
import script from "./BestellungWarenkorb.vue?vue&type=script&lang=js&"
export * from "./BestellungWarenkorb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports